export const getArrayOfSize = (size: number) => Array.from(new Array(size));
